<script>
  import { Avatar } from 'element-ui'
  export default {
    name:'ElAvatar',
    extends:Avatar
  }
</script>
